import { createEntityReducer } from 'ext/lib/collections';

const TYPE = 'userProperties';

export default createEntityReducer(TYPE);

export const selectUserProperties = state => state.userProperties;
